<template>
  <Form class="sm" ref="form" :model="form" :rules="rules" :label-width="100">
    <FormItem label="企业性质" prop="enterpriseType">
      <sl-select v-model="form.enterpriseType" type="select" dict="$enterpriseType"></sl-select>
    </FormItem>
    <FormItem label="企业名称" prop="name">
      <Input v-model="form.name"></Input>
    </FormItem>
    <FormItem label="联系电话" prop="contactPhone">
      <Input v-model="form.contactPhone"></Input>
    </FormItem>
    <FormItem label="统一信用代码" prop="unionCreditCode">
      <Input v-model="form.unionCreditCode"></Input>
    </FormItem>
    <FormItem label="注册地址" prop="regAddress">
      <Input v-model="form.regAddress"></Input>
    </FormItem>
    <FormItem label="所属品牌" prop="brand">
      <Input v-model="form.brand"></Input>
    </FormItem>
    <FormItem>
      <Button @click="reset()">重置</Button>
      <Button :loading="loading" @click="handleSubmit('form')" type="primary">确定</Button>
    </FormItem>
  </Form>
</template>
<script>
export default {
  data() {
    return {
      modalVisible:false,
      action:null,
      rules: {
        name: [ { required:true , message: '企业名称不能为空', trigger: 'blur,change' } ],
        contactPhone: [ { required:true , message: '联系电话不能为空', trigger: 'blur,change' } ],
        unionCreditCode: [ { required:true , message: '统一信用代码不能为空', trigger: 'blur,change' } ],
      },
      form: {
        id: null,
        name: null,
        contactPhone:null,
        unionCreditCode:null,
        enterpriseType:null,
        regAddress:null,
        brand:null,
      },
      loading:false
    }
  },

  props:{
    orderId:{

    }
  },
  watch:{
    orderId(val){
      if(val){
        this.query()
      }
    }
  },

  mounted() {},

  methods: {
    init(id) {
      this.orderId = id
    },

    query(){
      this.$request.orderCompanyQuery(this.orderId).then(resp => {
        if(!resp.code){
          this.def = resp.data || {}
          this.$utils.fill(this.form , this.def)
        }else{
          this.$Message.error({content:resp.message})
        }
      })
    },

    save() {
      let params = { ...this.form }

      this.loading = true
      this.$request.orderCompanyUpdate(params).then(resp => {
        if (resp.code) {
          this.$Message.error({ content: resp.msg })
        } else {
          this.$Message.success('操作成功')
          this.$emit('on-update')
          this.modalVisible = false
        }
        this.loading = false
      })

    },
    reset(){
      this.$utils.fill(this.form , this.def)
    },

    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.save()
        } else {
          this.$Message.error('参数错误');
        }
      })
    },

    handleChange(v){
    }
  }
}
</script>